// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".multi-line-button{border:1px solid;border-radius:4px;font-size:14px;font-weight:500;position:relative;text-transform:capitalize;width:100%}.multi-line-button:before{background-color:var(--v-primary-base);content:\"\";height:100%;left:0;opacity:0;position:absolute;top:0;transition:opacity .2s;width:100%}.multi-line-button:focus:before,.multi-line-button:hover:before{opacity:.08}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
